import { API_BASE } from "../AppConfig";
import * as JOBSTATE_VALIDATION from "./jobState_Validation"; // bad - has paper
import { GetRandomInt, deepCopy, fetchTimeout } from "../components/Common";
import { LoadSVGFromData, UpdateAllSVGMaterials } from "../components_designer/layout/PaperFunctions";
import Drawings from "../components_designer/main_drawer/Drawings";
import { GetBracketDataForOpal } from "../components_designer/main_drawer/BracketDesigner";

import {
    BEAMS_AND_POSTS_TOOL,
    DRAWER_TOOLSET_EXPANDED,
    DRAW_FULL_LAYOUT,
    SELECT_POINT,
    SET_TOOLSET_AREA,
    SHAPE_TOOL,
    SHOW_DESIGNER_MESSAGE,
    SHOW_LOADING_BAR,
    THREED_MODE,
    THREED_MINI_MODE,
    TOGGLE_DESIGNER,
    UPDATE_2D_DESIGNER_SVGS,
    UPDATE_3D_MODEL,
    checkInternetConnection,
    updateAPP,
    updateDesigner,
    GENERATING_DOCUMENT,
    GENERATING_DOCUMENT_STATUS,
    getImageBlob,
    blobToBase64,
    DOCUMENT_TO_SHOW,
} from "./appState";
import { NEW_JOB, updateDocument, updateQuoteParameters } from "./jobState";
import { GetShapeUpdateString } from "../components_designer/layout/PaperFunctionHelper";
import { loadingMeshMode } from "../components_designer/layout/Babylon3D";
import { jobStateErrorPopups } from "./jobStateWarningPopups";

const { convertJobStateToIni } = require("../components/Common_Conversions");

export const setToolSetArea =
    (area, toolset = null) =>
    (dispatch, getState) => {
        const last_toolset = getState().app.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
        let threeDMode = getState().app.designer[THREED_MODE];
        let threeDMiniMode = getState().app.designer[THREED_MINI_MODE];
        dispatch({
            type: SET_TOOLSET_AREA,
            area: area,
            toolset: toolset ? toolset : last_toolset,
        });
        if (
            toolset !== null &&
            (toolset === BEAMS_AND_POSTS_TOOL || toolset === SHAPE_TOOL || last_toolset === SHAPE_TOOL) &&
            (!threeDMode || (threeDMode && threeDMiniMode))
        ) {
            dispatch(updateLayout2D());
        }
        if (toolset !== null && last_toolset !== toolset) {
            window.app = { ...getState().app };
            UpdateAllSVGMaterials();

            if (toolset === BEAMS_AND_POSTS_TOOL && threeDMode) {
                dispatch(updateLayout2D());
            }
        }
    };

export const updateLayout2D =
    (mode = null, area_index = null, drawing_mode = null, force = false, job_data = null) =>
    (dispatch, getState) => {
        if (window.debug && window.location.href.includes("no_eng") && !force) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return;
        }
        window.loading3d = false;

        if (window.loading2d) {
            window.loading2d = false;
            return;
        }
        console.log("updateLayout2D");
        checkInternetConnection(dispatch);
        if (document.hidden) return;

        let online = getState().app.online;

        if (area_index === null) area_index = getState().app?.designer?.designer2D?.AREA_INDEX;
        if (!online)
            return new Promise((resolve) => {
                return resolve(false);
            });

        let user_id = getState().app.user.id;
        if (!job_data) job_data = getState().job;
        if (!job_data) {
            console.log("no job data");
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return new Promise((resolve) => {
                return resolve(false);
            });
        }

        if (!job_data.AreaSpecifications.length === 0) {
            console.log("no area data");
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return new Promise((resolve) => {
                return resolve(false);
            });
        }

        // dispatch({
        //     type: TOGGLE_DESIGNER,
        //     parameter: SHOW_LOADING_BAR,
        //     value: true,
        // });

        setTimeout(() => {
            if (window.loading2d) {
                dispatch({
                    type: TOGGLE_DESIGNER,
                    parameter: SHOW_LOADING_BAR,
                    value: true,
                });
            }
        }, 1500);

        // console.log("job_data", deepCopy(job_data), job_ini);

        const toolopen = getState().app.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
        const select_point = getState().app.designer.designer2D[SELECT_POINT];
        const draw_full_layout = getState().app.designer.designer2D[DRAW_FULL_LAYOUT];
        const threeDMode = getState().app.designer[THREED_MODE];
        const threeDMiniMode = getState().app.designer[THREED_MINI_MODE];

        let id = getState().job.id;

        let api_url = API_BASE() + "svg/" + id + "/selection";
        if (job_data.DesignParameters.DeckMode === 1) {
            api_url = API_BASE() + "svg/" + id + "/selection";
        } else if (toolopen === SHAPE_TOOL && job_data.DesignParameters.DeckMode !== 1 && !draw_full_layout) {
            api_url = API_BASE() + "svg/" + id + "/";
        } else if (toolopen === BEAMS_AND_POSTS_TOOL && area_index === -1 && !select_point) {
            api_url = API_BASE() + "svg/" + id + "/engineering";
            if (!job_data?.SiteParameters?.WindData?.WindZoneAS1170) {
                api_url = API_BASE() + "svg/" + id + "/selection";
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: {
                        message:
                            "Wind data loading in background. Proceed with job design. Engineering will load after Wind.",
                        type: "warning",
                    },
                });
            }
        }

        if (drawing_mode && drawing_mode === "engineering") {
            window.getting_engineering = true;
            api_url = API_BASE() + "svg/" + id + "/engineering";
            if (!job_data?.SiteParameters?.WindData?.WindZoneAS1170) {
                api_url = API_BASE() + "svg/" + id + "/selection";
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message:
                        "Error: Wind data must be defined to engineer this design. Please Wait until Wind has loaded.",
                });
            }
        }

        // if (api_url.includes("/engineering")) {
        //     job_data = deepCopy(job_data);
        //     job_data.SiteParameters.SpliceOffset = 0;
        // }

        console.log("App: ");
        console.log(getState().app);

        console.log("config: ");
        console.log(getState().config);

        let job_ini = convertJobStateToIni(job_data, getState().app, "", getState().config);

        window.loading2d = true;
        let request_id = Date.now();
        window.loading2d_id = request_id;
        if (window.loading2d_controller) window.loading2d_controller.abort();
        if (window.AbortController) {
            window.loading2d_controller = new AbortController();
        }

        if (mode) api_url = API_BASE() + "svg/" + id + "/" + mode;

        console.log(api_url);

        let timeout = 30000;
        if (job_data?.DesignParameters) {
            timeout =
                6000 +
                job_data.DesignParameters.NumFlat * 2000 +
                job_data.DesignParameters.NumGable * 3000 +
                job_data.DesignParameters.NumDeck * 2000;
        }

        if (api_url.includes("/engineering")) {
            timeout = timeout * 1.8;
        }

        if (window.debug) timeout = timeout * 3;

        console.log("2d timeout", timeout);

        return new Promise((resolve) => {
            fetchTimeout(
                api_url,
                {
                    signal: window?.loading2d_controller?.signal,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user_id: user_id,
                        job_id: job_data.id,
                        request_id: request_id,
                        job: job_ini,
                        wind_data: job_data?.SiteParameters?.WindData,
                        area_index: area_index,
                        session_id: window?.session_id,
                        business_code: job_data?.BusinessCode,
                        brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                        threed: threeDMode && threeDMiniMode ? true : false,
                    }),
                    retry: true,
                    retry_timeout: timeout * 2,
                    request_id: request_id,
                },
                timeout
            )
                .then(async (response) => {
                    console.log("RESPONSE", response);

                    if (response === undefined) {
                        dispatch({
                            type: TOGGLE_DESIGNER,
                            parameter: SHOW_LOADING_BAR,
                            value: false,
                        });
                        return resolve(false);
                    }

                    let json = await response.json();

                    // .then(json => {
                    if (json.request_id != window.loading2d_id) {
                        return resolve(false);
                    }
                    window.loading2d = false;
                    if (json.Error) {
                        if (json.Locked) {
                            if (job_data) {
                                let new_job = deepCopy(job_data);

                                new_job.App.Locked = true;
                                new_job.App.LockMessage = json.Error;

                                dispatch({
                                    type: NEW_JOB,
                                    parameter: new_job,
                                });
                            }

                            dispatch({
                                type: TOGGLE_DESIGNER,
                                parameter: SHOW_LOADING_BAR,
                                value: false,
                            });
                        } else {
                            throw json.Error;
                        }
                    }
                    if (json.obj_url) {
                        dispatch({
                            type: UPDATE_3D_MODEL,
                            parameter: "area_all",
                            value: json.obj_url,
                        });
                    }

                    if (json.Dimensions) {
                        dispatch(updateQuoteParameters("AREA_DIMENSIONS", json.Dimensions));
                    }

                    window.svg_data = null;
                    if (json["svg_data"]) {
                        window.job = { ...getState().job };
                        window.svg_data = json["svg_data"];

                        dispatch({
                            type: TOGGLE_DESIGNER,
                            parameter: SHOW_LOADING_BAR,
                            value: false,
                        });

                        console.log("json.svg", json.svg);
                        var svg_url = json["svg"];
                        // if ("Data" in json) {
                        //     dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
                        // }

                        // dispatch({
                        //     type: UPDATE_2D_DESIGNER_SVGS,
                        //     parameter: "area_all",
                        //     value: svg_url,
                        // });

                        if (!json["EngineeringResults"]) {
                            LoadSVGFromData(json["svg_data"], svg_url);
                        } else {
                            dispatch({
                                type: TOGGLE_DESIGNER,
                                parameter: SHOW_LOADING_BAR,
                                value: false,
                            });

                            dispatch(updateAPP("loadingEngineering", false));

                            if ("Data" in json) {
                                dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
                            }
                            if ("EngineeringResults" in json) {
                                let new_engineering = {
                                    ...getState().job.QuoteParameters.ENGINEERING,
                                    ...json,
                                };
                                window.job = { ...getState().job };
                                LoadSVGFromData(json["svg_data"], svg_url);

                                new_engineering.engineeringHashCode = GetShapeUpdateString(false, true);

                                new_engineering.svg_data = null;

                                new_engineering.EngineeringResults = json["EngineeringResults"];
                                dispatch(updateQuoteParameters("ENGINEERING", new_engineering));

                                setTimeout(function () {
                                    let job_to_check = { ...getState().job };
                                    if (job_to_check) {
                                        job_to_check.QuoteParameters.ENGINEERING = new_engineering;
                                        let warnings = JOBSTATE_VALIDATION.getWarnings(
                                            job_to_check,
                                            getState()?.app?.user,
                                            getState()?.config
                                        );
                                        // Add warnings from warningsHelper
                                        let standardErrors = jobStateErrorPopups({
                                            config: getState()?.config,
                                            job: job_to_check,
                                            dispatch: () => null,
                                            app: getState()?.app,
                                        });

                                        console.log(standardErrors);

                                        if (standardErrors) warnings["message"] = standardErrors.title;
                                        console.log("warnings", warnings);
                                        if (warnings && warnings.message)
                                            dispatch({
                                                type: SHOW_DESIGNER_MESSAGE,
                                                message: warnings.message,
                                            });
                                    }
                                }, 500);
                            }
                        }

                        // setTimeout(function () {
                        // }, 300);

                        resolve(true);
                        return;
                    }

                    dispatch(updateAPP("loadingEngineering", false));

                    if (json.svg) {
                        console.log("json.svg", json.svg);
                        var svg_url = json["svg"];
                        if ("Data" in json) {
                            dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
                        }
                        if ("EngineeringResults" in json) {
                            let new_engineering = {
                                ...getState().job.QuoteParameters.ENGINEERING,
                                ...json,
                            };
                            window.job = { ...getState().job };
                            new_engineering.engineeringHashCode = GetShapeUpdateString(false, true);

                            new_engineering.EngineeringResults = json["EngineeringResults"];
                            dispatch(updateQuoteParameters("ENGINEERING", new_engineering));

                            setTimeout(function () {
                                let job_to_check = { ...getState().job };
                                if (job_to_check?.QuoteParameters)
                                    job_to_check.QuoteParameters.ENGINEERING = new_engineering;
                                let warnings = JOBSTATE_VALIDATION.getWarnings(
                                    job_to_check,
                                    getState()?.app?.user,
                                    getState()?.config
                                );
                                // Add warnings from warningsHelper
                                let standardErrors = jobStateErrorPopups({
                                    config: getState()?.config,
                                    job: job_to_check,
                                    dispatch: () => null,
                                    app: getState()?.app,
                                });

                                console.log(standardErrors);

                                if (standardErrors?.length > 0) warnings["message"] = standardErrors.title;

                                console.log("warnings", warnings);
                                if (warnings && warnings.warning)
                                    dispatch({
                                        type: SHOW_DESIGNER_MESSAGE,
                                        message: warnings.message,
                                    });
                            }, 1000);
                        }
                        console.log("post svg dipatch");

                        if (json["svg_data"]) {
                            // dispatch({
                            //     type: TOGGLE_DESIGNER,
                            //     parameter: SHOW_LOADING_BAR,
                            //     value: false,
                            // });
                            // LoadSVGFromData(json["svg_data"]);
                            // dispatch({
                            //     type: UPDATE_2D_DESIGNER_SVGS,
                            //     parameter: "area_all",
                            //     value: svg_url,
                            // });
                        } else {
                            dispatch({
                                type: UPDATE_2D_DESIGNER_SVGS,
                                parameter: "area_all",
                                value: svg_url,
                            });
                        }
                        resolve(true);
                    } else {
                        dispatch({
                            type: TOGGLE_DESIGNER,
                            parameter: SHOW_LOADING_BAR,
                            value: false,
                        });
                        resolve(false);
                    }
                })
                .catch((e) => {
                    if (e?.message?.includes && e.message.includes("aborted")) {
                        console.log("ABORTED", e.message);
                        return resolve(false);
                    }
                    window.loading2d = false;
                    console.log("ERROR", e.message);

                    let message = "Error loading layout from QikQuote server.";
                    if (typeof e === "string") message = e;
                    if (e.message === "failed to fetch")
                        message = "SERVER NOT REACHABLE. Check internet connection, then try again in a few minutes...";
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                    dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: "Error: " + message,
                    });
                    return resolve(false);
                    // handle errors and timeout error
                }); // parses JSON response into native Javascript objects
        });
    };

export const updateLayout3D =
    (force = false, job_data = null) =>
    (dispatch, getState) => {
        checkInternetConnection(dispatch);

        let user_id = getState().app.user.id;
        let online = getState().app.online;
        if (!online) return;
        if (document.hidden) return;
        window.loading2d = false;

        const threeDMode = getState().app.designer[THREED_MODE];
        const threeDMiniMode = getState().app.designer[THREED_MINI_MODE];

        if (threeDMode && threeDMiniMode && !force) return; // this is catered for in combined request in SVG

        // if (!checkInternetConnection(dispatch)) {
        //     return;
        // }

        if (!job_data) job_data = getState().job;
        if (!job_data) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return;
        }
        if (!job_data?.AreaSpecifications?.length) {
            dispatch({
                type: TOGGLE_DESIGNER,
                parameter: SHOW_LOADING_BAR,
                value: false,
            });
            return;
        }

        let job_ini = convertJobStateToIni(job_data, getState().app, "3D", getState().config);

        let id = getState().job.id;

        let api_url = API_BASE() + "obj/" + id;

        setTimeout(() => {
            if (window.loading3d) {
                loadingMeshMode();

                dispatch({
                    type: TOGGLE_DESIGNER,
                    parameter: SHOW_LOADING_BAR,
                    value: true,
                });
            }
        }, 1500);

        window.loading3d = true;
        let request_id = Date.now();
        window.loading3d_id = request_id;

        if (window.loading3d_controller) window.loading3d_controller.abort();
        if (window.AbortController) window.loading3d_controller = new AbortController();

        let timeout = 12000;
        if (job_data?.DesignParameters) {
            timeout =
                6000 +
                job_data.DesignParameters.NumFlat * 3000 +
                job_data.DesignParameters.NumGable * 4000 +
                job_data.DesignParameters.NumDeck * 3000;
        }

        return fetchTimeout(
            api_url,
            {
                signal: window?.loading3d_controller?.signal,
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: user_id,
                    job_id: job_data.id,
                    job: job_ini,
                    request_id: request_id,
                    session_id: window?.session_id,
                    business_code: job_data?.BusinessCode,
                    brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                }),
                retry: true,
                retry_timeout: timeout * 1.3,
                request_id: request_id,
            },
            timeout
        )
            .then(async (response) => {
                console.log("RESPONSE", response);

                if (response === undefined) {
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                    return;
                }

                let json = await response.json();

                if (json.request_id != window.loading3d_id) return;
                if (response === undefined) return;

                window.loading3d = false;
                if (json.Error) {
                    throw json.Error;
                }
                if (json.obj_url) {
                    dispatch({
                        type: UPDATE_3D_MODEL,
                        parameter: "area_all",
                        value: json.obj_url,
                    });

                    if (json.Locked) {
                        if (job_data) {
                            let new_job = deepCopy(job_data);

                            new_job.App.Locked = true;
                            new_job.App.LockMessage = json.LockMessage;

                            dispatch({
                                type: NEW_JOB,
                                parameter: new_job,
                            });
                        }
                    }
                } else {
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                }
            })
            .catch((e) => {
                if (e?.message?.includes && e.message.includes("aborted")) {
                    return;
                }

                window.loading3d = false;

                console.log("3D ERROR", e);

                let message = "Error loading model from QikQuote server.";
                if (e?.message) message = e.message;
                if (e.message === "failed to fetch")
                    message = "SERVER NOT REACHABLE. Check internet connection, then try again in a few minutes...";
                dispatch({
                    type: TOGGLE_DESIGNER,
                    parameter: SHOW_LOADING_BAR,
                    value: false,
                });
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: "Error: " + message,
                });

                // handle errors and timeout error
            }); // parses JSON response into native Javascript objects
    };

export const updateDocumentData =
    (job_data, document_type, timeout = 100000) =>
    async (dispatch, getState) => {
        console.log("updateDocumentData", document_type);
        const config = getState()?.config;
        const designTemplate = job_data?.AreaSpecifications[0]?.SHAPE?.DesignTemplateName;
        const num_areas = job_data.AreaSpecifications.length;
        let appendPDF = [];
        timeout += num_areas * 20000;

        if (document_type === "Production Layouts") {
            appendPDF = Drawings(job_data, config);
        }

        if (designTemplate && document_type === "Job Summary Layouts") {
            const searchCondition = {
                "Area.DesignTemplateName": designTemplate,
            };

            appendPDF = Drawings(job_data, config, null, null, searchCondition);
        }

        if (Array.isArray(document_type)) {
            appendPDF = document_type;
            document_type = "";
        }

        let api_url = API_BASE() + "document/" + job_data.id + "/" + document_type;

        let user_id = getState().app.user.id;
        let job_ini = convertJobStateToIni(job_data, getState().app, "", getState().config);
        dispatch(updateDesigner(GENERATING_DOCUMENT, document_type));
        dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, "1,Contacting Server"));

        let threedlayout = job_data?.QuoteParameters?.DOCUMENTS?.["3DScreenShots"]?.[0];
        let threed_screenshot = null;
        if (threedlayout) {
            let threed_screenshot_url = API_BASE() + "document/" + job_data.id + "/" + threedlayout;
            let blob = await getImageBlob(threed_screenshot_url);
            let base64 = await blobToBase64(blob);
            threed_screenshot = base64;
        }

        let business_logo = null;
        if (job_data.Distributor.Logo) {
            let business_logo_url =
                API_BASE() + "document/BUS_" + job_data.Distributor.Code + "/" + job_data.Distributor.Logo;
            let blob = await getImageBlob(business_logo_url);
            if (blob) {
                let base64 = await blobToBase64(blob);
                business_logo = base64;
            }
        }

        let job_raw = {};
        let material_list = job_data?.QuoteParameters?.BOM?.OrderList;
        if (!material_list || !material_list?.items) material_list = job_data?.QuoteParameters?.BOM?.SystemList;

        let bracketData = [];
        if (document_type === "TEST BRACKETS" || document_type === "Production Layouts") {
            bracketData = GetBracketDataForOpal(material_list, job_data);
        }

        if (document_type === "Quote Layout") {
            job_raw = {
                ...job_data,
                QuoteParameters: {
                    ...job_data.QuoteParameters,
                    BOM: null,
                },
            };
        }

        let request_id = Date.now() + "_" + GetRandomInt(1000, 9999);

        const checkDocumentStatus = () => {
            let generatingState = getState().app?.designer?.GENERATING_DOCUMENT;

            if (generatingState) {
                fetchTimeout(
                    API_BASE() + "document/" + job_data.id + "/" + request_id + ".status",
                    {
                        method: "GET", // *GET, POST, PUT, DELETE, etc.
                    },
                    2000
                ).then(async (response) => {
                    if (response.status && response.status >= 200 && response.status <= 300 && response?.text) {
                        let response_text = await response.text();
                        dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, response_text));
                        setTimeout(function () {
                            checkDocumentStatus();
                        }, 1000);
                    } else {
                        console.log("checked response:" + response);
                    }
                });
            }
        };
        setTimeout(function () {
            checkDocumentStatus();
        }, 1000);

        return fetchTimeout(
            api_url,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    document_type: document_type,
                    user_id: user_id,
                    job_id: job_data.id,
                    job: job_ini,
                    order_list: material_list,
                    wind_data: job_data?.SiteParameters?.WindData,
                    brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                    job_raw:
                        document_type === "Quote Layout" ||
                        document_type === "Council Report" ||
                        document_type === "Production Layouts" ||
                        //DES-683 - Bolt to Slab (Internal/External) implementation
                        document_type === "Footing Layouts"
                            ? job_data
                            : null,
                    threed_screenshot: threed_screenshot,
                    business_logo: business_logo,
                    request_id: request_id,
                    appendPDF: appendPDF,
                    bracketData: bracketData,
                    numAreas: num_areas,
                }), // body data type must match "Content-Type" header
            },
            timeout
        )
            .then(async (response) => {
                if (response?.status && response.status >= 200 && response.status <= 300) {
                    let json = await response.json();

                    console.log(json);
                    if (json.Error) {
                        throw json;
                    } else if (json.document_filename) {
                        dispatch(updateDocument(document_type, json.document_filename));
                        // dispatch(updateQuoteParameters("DOCUMENTS",new_document_data));
                        dispatch(updateDesigner(DOCUMENT_TO_SHOW, json.document_filename));
                        dispatch(updateDesigner(GENERATING_DOCUMENT, false));
                    } else {
                    }

                    dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, false));
                } else {
                    // if  (window.debug) console.log("response",response);
                    // if  (response.text) console.log("response",await response.text());
                    dispatch(updateDesigner(GENERATING_DOCUMENT, false));
                    dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, false));
                    throw {
                        message: "Could not generate layout at this time. Please wait a moment and try again.",
                    };
                }
            })
            .catch((e) => {
                console.log("ERROR", e);

                let message = "Could not generate layout at this time. Please wait a moment and try again.";
                if (e?.message) message = e.message;
                if (e?.message === "failed to fetch") message = "Error loading ... QikQuote server is not accesible.";
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: "Error: " + message,
                });
                dispatch(updateDesigner(GENERATING_DOCUMENT, false));
                dispatch(updateDesigner(GENERATING_DOCUMENT_STATUS, false));
                // handle errors and timeout error
            }); // parses JSON response into native Javascript objects
    };

export const DStateActive = ({ config }) => {
    let DStateActive = config.region?.D365_State_Active;
    if (DStateActive !== true) {
        DStateActive = false; // Case null or undefined
    }
    return DStateActive;
};
